import React, { useEffect, useState } from "react";
import { Button, Col, Row, Stack, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import inventoryApi from "../api/inventoryApi";

import moment from "moment"

import {
  DatatableWrapper,
  Filter,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { Link } from "react-router-dom";

const IEPList = () => {
  const navigate = useNavigate();
  const [body, setBody] = useState([]);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [period, setPeriod] = useState("");

  const createIEPRoles = ['Inclusive Teacher', 'Vocational Teacher', 'CBR Worker'];

  useEffect(() => {
    fetchAllAssessment();


  }, []);
  const fetchAllAssessment = async () => {
    setYear("")
    setMonth("")
    setPeriod("")
    const result = await inventoryApi.fetchAssessmentsWithStudentsName();
    if (result) {
      //let tempBody = result.map((data, index) => ({ ...data, index: index + 1 }));
      setBody(result);
    } else {
      setBody([]);
    }
  }

  const findAssementWithYear = async () => {
    const result = await inventoryApi.findAssementWithYear({ year, month, period });
    if (result) {
      setBody(result);
    } else {
      setBody([]);
    }
  };
  // Create table headers consisting of 4 columns.
  const header = [

    {
      title: "Category", prop: "category", isFilterable: true,
      cell: (row) => (
        <Link
          to={"/assessments/" + row.id}
          state={row}
        >
          {row.category}
        </Link>
      )

    },
    { title: "Start Date", prop: "startdate", isFilterable: true, cell: (row) => moment(row.startdate).format("DD-MM-YYYY"), },
    { title: "End Date", prop: "enddate", isFilterable: true, cell: (row) => moment(row.enddate).format("DD-MM-YYYY"), },
    { title: "Status", prop: "status", isFilterable: true },
    { title: "Staff Name", prop: "staffname", isFilterable: true },
    { title: "Period", prop: "period", isFilterable: true },
    { title: "Students", prop: "studentnames", isFilterable: false }, // Added By Jaseem
    { title: "Remarks", prop: "remarks", isFilterable: true }, 
    // {
    //   title: "Actions",
    //   prop: "id",
    //   cell: (row) => (
    //     <Button className="btn-sm mx-2" onClick={() => editIEP({ row })}>
    //       <i className="fa-regular fa-pen-to-square"></i>
    //     </Button>
    //   ),
    // },
  ];

  // Randomize data of the table columns.
  // Note that the fields are all using the `prop` field of the headers.

  const editIEP = (row) => {
    navigate(`/ieps/${row.row.id}/e`, { state: row });
  };

  const createIEP = () => {
    navigate(`/ieps/e`);
  };

  return (
    <Row className="g-0">
      <Col lg={2} className="mx-2">
        <Link className="nav-link">
          Assessments <i className="fa-solid fa-chevron-right"></i> IEP
        </Link>
      </Col>

      <Col lg={12} className="p-lg-4">
        <DatatableWrapper
          body={body}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 10,
              options: [5, 10, 15, 20],
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            >
              <Filter />
            </Col>
            {
              /**
               * RMKM Phase 2 
               * Added by @jaseem
               * Date : 21 Apr 2025
               * Desc : IEP Filter work session or quarter wise
               */
            }
            <Col lg={4}>
              <Stack direction="horizontal" gap={1}>
                <select
                  className="form-control"
                  value={period}
                  onChange={(e) => setPeriod(e.target.value)}
                >
                  <option value="">Select Period</option>
                  <option value="JAN TO JUNE">JAN TO JUNE</option>
                  <option value="JULY TO DEC">JULY TO DEC</option>
                  <option value="JUN TO MARCH">JAN TO MARCH</option>
                  <option value="JULY TO SEPT">JULY TO SEPT</option>
                  <option value="OCT TO DEC">OCT TO DEC</option>
                </select>
                <select
                  className="form-control"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                >
                  <option value="">Month</option>
                  {[...Array(12)].map((_, i) => (
                    <option key={i + 1} value={i + 1}>
                      {new Date(0, i).toLocaleString("default", { month: "long" })}
                    </option>
                  ))}
                </select>
                <select
                  className="form-control"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                >
                  <option value="" aria-readonly>Year</option>
                  {[...Array(2050 - 2020 + 1)].map((_, i) => (
                    <option key={i + 2020} value={i + 2020}>
                      {i + 2020}
                    </option>
                  ))}
                </select>
              </Stack>
            </Col>

            <Col lg={2}>
              <Stack direction="horizontal" gap={2}>
                <Button variant="primary" onClick={findAssementWithYear}>
                  Apply Filter
                </Button>
                <Button variant="success" onClick={() => { fetchAllAssessment() }}>
                  <i class="fa-solid fa-rotate-right"></i>
                </Button>
              </Stack>
            </Col>
            {/* End Filter Work */}

            {
              // (localStorage.getItem('userrole') == "SUPER_ADMIN" || createIEPRoles.includes(localStorage.getItem("usertype"))) && (
                <Col
                  xs={12}
                  sm={6}
                  lg={2}
                  className="d-flex flex-col justify-content-end align-items-end"
                >
                  <Button
                    className="btn-sm"
                    variant="outline-primary"
                    onClick={() => createIEP(true)}
                  >
                    Create IEP
                  </Button>
                </Col>
              // )
            }
          </Row>

          {/*  {body.length>0 ? */}
          <Table striped className="data-table">
            <TableHeader />
            <TableBody />
          </Table>
          {/* :
             ""} */}
          <Pagination />
        </DatatableWrapper>
      </Col>
    </Row>
  );
};

export default IEPList;
